module.exports = __webpack_public_path__ + "img/schloss.fca90351.svg";